
    "use strict";
    var $ = require('@alife/alpha-jquery/jquery');
    var cookieInfoSimpleObj = require('./cookie-info-simple');
    var cookie = require('@alife/alpha-cookie/cookie');
    var storeProxy = require('@alife/alpha-store-proxy/store-proxy');
    var STORE_KEY = 'cookie-info-storeproxy-ipdata';

    var ipInfo  = {

        _getIPData: function( callback ){
            var ipDataUrl = '//www.alibaba.com/detail/ajax/queryIpAjax.do';
            if( typeof(callback) === 'function' ){
                $.ajax({
                    url: ipDataUrl,
                    type:'get',
                    dataType: 'jsonp',
                    data:{},
                    cache: false,
                    jsonp:'jsonp',
                    timeout: 3000

                }).done($.proxy(function( resultData ){
                    var ipData = {},
                        storeVal = [];
                    if( typeof( resultData ) === 'object' && typeof( resultData.countryCode ) === 'string' ){
                       ipData.cityName = resultData.cityName;
                       ipData.countryCode = resultData.countryCode;
                       ipData.regionName = resultData.regionName;
                       ipData.updateTime = (new Date()).getTime();
                       ipData.success = true;
                       storeVal.push( ipData.cityName );
                       storeVal.push( ipData.countryCode );
                       storeVal.push( ipData.regionName );
                       storeVal.push( ipData.updateTime );
                       storeProxy.set(STORE_KEY, storeVal.join('|'));

                       callback.call( this, ipData );
                    }
                },this)).fail($.proxy(function( resultData ){
                     callback.call( this, { success: false } );
                },this));
            }

        },

        getIPData: function( callback ){

            storeProxy.get( STORE_KEY,$.proxy(function(err, data){
                var result = false;
                if( typeof( data ) === 'string' && typeof( callback ) === 'function' ){
                    var storeArr = data.split('|'),
                        ipData = {};
                    if( storeArr.length === 4 ){
                       ipData.cityName = storeArr[0];
                       ipData.countryCode = storeArr[1];
                       ipData.regionName = storeArr[2];
                       ipData.updateTime = Number( storeArr[3] );
                       var nowTime = (new Date()).getTime();
                       var diffTime = nowTime - ipData.updateTime;

                       //缓存半小时
                       if( diffTime < 30*60*1000 && diffTime > 0 ){
                            result = true;
                            callback.call(this, ipData );
                       }
                    }

                }
                if( result === false ){
                    this._getIPData( callback );
                }
            },this));
            

        }

       
    };

    cookieInfoSimpleObj.getIPData = function( callback ){
        ipInfo.getIPData( callback );
    };
    cookieInfoSimpleObj.getCountryAlways = function( callback ){
        var ct = this.getCountry();
        if( typeof(callback) === 'function' ){
            if( typeof(ct) === 'string' && ct !== '' ){
                callback.call(this, ct );
            }else{
                ipInfo.getIPData($.proxy(function( ipData ){
                    if( ipData.success === false ){
                        if( this.getIsOversea() === true ){
                            callback.call(this, 'US' );
                        }else{
                            callback.call(this, 'CN' );
                        }
                       
                    }else{
                        callback.call(this, ipData.countryCode );
                    }
                    
                },this));
            }
        }
    }.bind(cookieInfoSimpleObj);


    module.exports = cookieInfoSimpleObj;
